import { getPlayerSessionId } from "../../helpers";

async function sendChangeStatusRequest(status: string, effect: boolean): Promise<boolean> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/status/change`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: JSON.stringify({ status, effect }),
        });

        const result: any = await response.json();

        console.log(result);

        if (!result) {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
    }
    return false;
}

export default sendChangeStatusRequest;
